/** @format */

// has raw color #rawcolor (comment to help find the comp in the near future for further updates)

import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Icon} from './icon';

export function Badge({children, icon, iconColor, large, positive, count, showZero, ...props}) {
    const badgeClass = classNames(
        'badge',
        positive ? 'bg-alert-positive' : 'bg-alert-negative',
        large ? 'font-label-md' : 'font-label-xs'
    );

    return (
        <span className="has-badge" {...props}>
            {children}
            {large && <Icon name={icon} large color={iconColor} />}
            {!large && <Icon name={icon} medium color={iconColor} />}
            {(count > 0 || showZero) && <sup className={badgeClass}>{count}</sup>}
        </span>
    );
}

Badge.propTypes = {
    count: PropTypes.number,
    large: PropTypes.bool,
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    positive: PropTypes.bool,
    showZero: PropTypes.bool
};

Badge.defaultProps = {
    count: 0,
    iconColor: '#26313a',
    icon: 'Cart'
};
